import { createApi } from "@reduxjs/toolkit/query/react";

import type { QueryRow } from "../../../types/QueryRow";
import { createServiceBaseQuery } from "../../../../../store/client/serviceBaseQuery";

export const queryService = createApi({
  reducerPath: "queryService",
  baseQuery: createServiceBaseQuery("orpheusUri"),
  tagTypes: ["Query"],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    executeQuery: builder.query<QueryRow[], { query: string }>({
      query: (data) => ({
        url: `/api/query/v2/execute`,
        method: "POST",
        body: { q: data.query },
      }),
      providesTags: [{ type: "Query", id: "LIST" }],
    }),
  }),
});

export const { useExecuteQueryQuery } = queryService;
